import React from 'react'

import {List, ListProps} from '@mui/material'

import MenuItem, {ItemProps} from '@progyny/components/MenuList/MenuItem'
import {useCompany} from '@progyny/hooks/useCompany'
import {useMeStore} from '@progyny/store/meStore'

interface MenuListProps extends ListProps {
  items: Array<ItemProps>
}

const MenuList: React.ComponentType<MenuListProps> = ({
  items,
  ...listProps
}: MenuListProps) => {
  const isCompanyMeta = useCompany('Meta')
  const companyHasBudget = useMeStore((s) => s.companyHasBudget)
  const filteredItems = items.filter((item, index) => index !== 3)
  const processedItems = isCompanyMeta
    ? filteredItems
    : items.filter((item) => !(item.withBudget && !companyHasBudget))

  return (
    <List {...listProps}>
      {processedItems.map((item, idx) => (
        <MenuItem key={idx} {...item} />
      ))}
    </List>
  )
}

export default MenuList
